import React from 'react';
import RequiredIcon from './RequiredIcon';

interface RequiredFieldLabelProps {
  isInvalid: boolean;
  className?: string;
}

const RequiredFieldLabel: React.FC<RequiredFieldLabelProps> = (data) => {
  const { children, isInvalid, className } = data;

  return (
    <span className={className}>
      {children}
      {' '}
      <RequiredIcon isInvalid={isInvalid} />
    </span>
  );
};

export default RequiredFieldLabel;
